export default "__VITE_ASSET__cbbc8f21__"